import script from "./ArticleDetailView.vue?vue&type=script&lang=js"
export * from "./ArticleDetailView.vue?vue&type=script&lang=js"

import "./ArticleDetailView.vue?vue&type=style&index=0&id=86cce5dc&lang=scss"

const __exports__ = script;

export default __exports__